var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadingOrigin)?_c('BlockUI',{attrs:{"message":_vm.message,"html":_vm.html}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }